import { render, staticRenderFns } from "./InviteIndex.vue?vue&type=template&id=0f2de2d7&"
import script from "./InviteIndex.vue?vue&type=script&lang=js&"
export * from "./InviteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports